export default {
      id: "as-on-site-parking-usage",
      viewBox: "0 0 56 56",
      url: "/" + "sprite.svg#as-on-site-parking",
      toString: function () {
        return this.url;
      }
    }